"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getRgbaFromHex = _interopRequireDefault(require("../../utils/getRgbaFromHex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var SideMenuSubmenu = {
  styles: function styles(theme) {
    return {
      mainItem: {
        fontWeight: 600,
        fontSize: theme.typography.fontSize,
        "&:hover": {
          background: theme.colors.baseContrast020,
          color: theme.colors.baseContrast080
        }
      },
      activeMainItem: {
        // eslint-disable-next-line @atg/css-rtl-support
        paddingLeft: theme.spacing.base * 2,
        borderLeft: {
          width: theme.spacing.base
        }
      },
      disabledMainItem: {
        color: theme.colors.baseContrast050,
        background: "transparent",
        "&:hover": {
          color: theme.colors.baseContrast050
        }
      },
      indicator: {
        fill: theme.colors.baseContrast080
      },
      subItem: {
        "&:hover": {
          color: theme.colors.baseContrast080
        }
      },
      activeSubmenuItem: {
        "&, & a": {
          background: theme.colors.primary,
          color: theme.colors.textOnDark,
          "&:hover, &:focus-visible": {
            background: theme.colors.primary,
            color: (0, _getRgbaFromHex.default)(theme.colors.textOnDark, 0.9)
          }
        }
      },
      disabledSubmenuItem: {
        color: theme.colors.baseContrast050,
        "&:hover": {
          color: theme.colors.baseContrast050
        }
      }
    };
  }
};
var _default = exports.default = SideMenuSubmenu;